import type { TOC } from '@ember/component/template-only';
import ActionItemTemplate from 'garaje/components/homepage/kiosk-demo/pages/templates/action-item-template';
import PageTemplate from 'garaje/components/homepage/kiosk-demo/pages/templates/page-template';
import type { KioskDemoPage } from 'garaje/components/homepage/kiosk-demo/provider';

interface HostSelectionPageSignature {
  Args: KioskDemoPage;
}

export default <template>
  <PageTemplate
    @headerTitle="Choose host"
    @headerInfo="Sign in typically includes selecting an employee as host. The employee will be notified that their visitor has arrived."
    @currentStep={{@currentStep}}
    @totalStepCount={{@totalStepCount}}
    @demoName={{@demoName}}
    @isUserLoggedIn={{@isUserLoggedIn}}
    @isDemoInstance={{@isDemoInstance}}
  >
    <div>
      <ActionItemTemplate
        @header="Add employees"
        @headerInfo="Add employees for visitors to select as host."
        @subHeader="Unlimited employees on Premium"
        @iconLink="/assets/images/ipad-demo/icons/team.svg"
        @iconAlt="Image of sign in flow"
        @pageLink="/employees"
        @isUserLoggedIn={{@isUserLoggedIn}}
        @demoName={{@demoName}}
        @isDemoInstance={{@isDemoInstance}}
      />
    </div>
  </PageTemplate>
</template> satisfies TOC<HostSelectionPageSignature>;
